// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__36OLY","imageUploader":"EGiftCard_imageUploader__vvce4"};